import { TextInput } from 'components/Inputs/TextInput';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { ISignIn } from 'types/Auth';
import ReCAPTCHA from 'react-google-recaptcha';

import { Box, FormHelperText, Grid, Typography } from '@mui/material';

import { ForgotPasswordLink } from './ForgotPasswordLink';
import { PasswordInput } from 'components/Inputs/PasswordInput';
import { CPFInput } from 'components/Inputs/CPFInput';
import { Controller, useFormContext } from 'react-hook-form';
import { CreateAccountLink } from './CreateAccountLink';

export const LoginForm: FC = ({ children }) => {
  const { userRole } = useParams<{ userRole: ISignIn['role'] }>();
  const { setValue } = useFormContext<ISignIn>();

  const onChangeCaptcha = (captchaToken: string | null) => {
    if (captchaToken) {
      setValue('captchaToken', captchaToken);
    }
  };

  return (
    <Box
      sx={{ height: '100%' }}
      alignContent="center"
      alignItems="center"
      justifyContent="space-evenly"
      display="flex"
      flexDirection="column"
      flex={1}
      py={4}
    >
      <Grid container spacing={2} sx={{ px: { xl: 12, lg: 8, md: 4, sm: 4 } }}>
        <Grid item container xs={12} justifyContent="center">
          <Typography
            component="h1"
            variant="h5"
            sx={{ fontWeight: 400, fontSize: 24 }}
          >
            Acesse sua conta
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {userRole === 'partner' || userRole === 'company' ? (
            <TextInput name="email" id="email" label="E-mail" required />
          ) : (
            <CPFInput required />
          )}
        </Grid>

        <Grid item xs={12}>
          <PasswordInput
            required
            fullWidth
            id="password"
            name="password"
            label="Senha"
          />
        </Grid>

        {userRole !== 'admin' && (
          <Grid item xs={12}>
            <ForgotPasswordLink />
          </Grid>
        )}
      </Grid>

      <Controller
        name="captchaToken"
        render={({ fieldState: { error } }) => (
          <Box>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_V2_API_KEY as string}
              onChange={onChangeCaptcha}
              hl="pt-BR"
            />

            <FormHelperText error={Boolean(error)}>
              {error?.message}
            </FormHelperText>
          </Box>
        )}
      />

      <Box sx={{ width: '100%', px: { xl: 12, lg: 8, md: 4, sm: 4 } }}>
        {children}

        <Box minHeight={20}>
          {(userRole === 'partner' || userRole === 'tutor') && (
            <CreateAccountLink />
          )}
        </Box>
      </Box>
    </Box>
  );
};
